import React from 'react'
import {StyleSheet, View} from 'react-native'

import {ChaosEnabled} from '@possible/chaos'
import {usePageViewedAnalytics} from 'src/lib/Analytics/usePageViewedAnalytics'
import {Loading} from 'src/designSystem/components/atoms/Loading/Loading'
import {MakePaymentAmountEntryTemplate} from 'src/products/general/MakePayment/MakePaymentAmountEntry/MakePaymentAmountEntryTemplate'
import {usePfDispatch} from 'src/store/utils'
import {BaseTemplate} from 'src/products/general/components/templates/BaseTemplate/BaseTemplate'
import {MakePaymentAmountEntryContainerProps} from 'src/products/general/MakePayment/MakePaymentAmountEntry/MakePaymentAmountEntry.types'

const MakePaymentAmountEntryContainer: React.FC<MakePaymentAmountEntryContainerProps> = (props) => {
  const {isLoading, pageViewedAnalytics, testID, onErrorBoundary: handleOnErrorBoundary} = props

  usePageViewedAnalytics(pageViewedAnalytics)
  const disaptch = usePfDispatch()

  if (isLoading) {
    return (
      <View testID="MakePaymentAmountEntry-Loading" style={styles.loadingContainer}>
        <Loading type={'loader0'} size={'large'} />
      </View>
    )
  }
  const {
    buttonActionEventProps,
    buttonActions,
    handleOnChangeSelectedButton,
    isAmountInputEditable,
    onPressContinue,
    paymentAmount,
    paymentTrackingId,
    infoNoticeText,
    alertData,
    handleOnChangeCustomPaymentOption,
  } = props
  const handleOnPressContinue = onPressContinue

  const paymentValue = paymentAmount
  const isValidPayment = Number(paymentValue) > 0 && !alertData.shouldShowAlert
  return (
    <BaseTemplate onErrorBoundary={handleOnErrorBoundary}>
      <ChaosEnabled componentName={testID} dispatch={disaptch}>
        <MakePaymentAmountEntryTemplate
          buttonActionEventProps={buttonActionEventProps}
          buttonActions={buttonActions}
          isAmountInputEditable={isAmountInputEditable}
          isValidPayment={isValidPayment}
          onPressButtonAction={handleOnChangeSelectedButton}
          onPressContinue={handleOnPressContinue}
          paymentValue={paymentValue}
          onChange={handleOnChangeCustomPaymentOption}
          paymentTrackingId={paymentTrackingId}
          infoNoticeText={infoNoticeText}
          alertData={alertData}
        />
      </ChaosEnabled>
    </BaseTemplate>
  )
}

export {MakePaymentAmountEntryContainer}

const styles = StyleSheet.create({
  loadingContainer: {
    display: 'flex',
    height: '100%',
  },
})
